var _path, _mask, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOffersCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 49C38.2548 49 49 38.2548 49 25C49 11.7452 38.2548 1 25 1C11.7452 1 1 11.7452 1 25C1 38.2548 11.7452 49 25 49Z",
  fill: "#FFA132",
  fillOpacity: 0.2,
  stroke: "#FFA132",
  strokeWidth: 2
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 50,
  height: 50
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 49C38.2548 49 49 38.2548 49 25C49 11.7452 38.2548 1 25 1C11.7452 1 1 11.7452 1 25C1 38.2548 11.7452 49 25 49Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33 20H17C15.8954 20 15 20.8954 15 22V32C15 33.1046 15.8954 34 17 34H33C34.1046 34 35 33.1046 35 32V22C35 20.8954 34.1046 20 33 20Z",
  stroke: "#FFA132",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M29 34V18C29 17.4696 28.7893 16.9609 28.4142 16.5858C28.0391 16.2107 27.5304 16 27 16H23C22.4696 16 21.9609 16.2107 21.5858 16.5858C21.2107 16.9609 21 17.4696 21 18V34",
  stroke: "#FFA132",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOffersCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/offers-circle.d47f65d0.svg";
export { ForwardRef as ReactComponent };